export const LalunaDarkColor = "#1C1C1C";
export const LalunaOverlayColor = "#606060";
export const NavbarOverlayColorOpacity = 0.3;
export const LalunaAccentColor = "#A08036";
export const LalunaAccentColorLighter = "#D4AB4D";
